import React, { useEffect, useState, useRef } from "react";
import "./locationsConfiguration.css";
import { Wrapper } from "../../../../components/Wrapper/Wrapper";
import iconSearch from "../../../../assets/Icons/search_icon.svg";
import { ExpandableConfigModComponent } from "../expandable/ExpandableConfigModComponent";
import { NavBar } from "../../../../components/NavBar/NavBar";
import { Checkbox, FormControlLabel, FormGroup, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  getLocations,
  saveLocation,
} from "../../services/locationsConfigurationService";
import {
  localStorageSave,
  localStorageGet,
} from "../../../../services/localStorageService";
import { environment } from "../../../../environments/environment";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { Sorting } from "../../../../components/Lists/Sorting";
import { use } from "react";
import { useDispatch } from "react-redux";
import {
  addTab,
  clearActiveTab,
} from "../../../../redux/features/TabsManager/tabSlice";
import { LocationsContextProvider } from "../../contexts/LocationsContext";
import { dropdownConfig } from "../../../../services/dropdownsConfigService";
import Dropdowns from "../../../../components/Dropdowns/Dropdowns";
import { Value } from "sass";
import {
  createFiltersConfig,
  FiltersManager,
} from "../../../../components/FiltersManager/FiltersManager";
import { SortingButton } from "../../../../components/Sorting/SortingButton";
import { SortingHeader } from "../../../../components/Sorting/SortingHeader";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { FiltersAndSorting } from "../../../../components/FiltersAndSorting/FiltersAndSorting";
// import { FixedSizeList as List } from "react-window";

export const LocationsConfigurationComponent = () => {
  const draftPrefix = "configuration/locationConfiguration/draft/location";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clearTabsAndNavigate = (path) => {
    dispatch(clearActiveTab());
    navigate(path);
  };
  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => clearTabsAndNavigate("/secure/customdashboard")}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => clearTabsAndNavigate("/secure/configuration")}
    >
      Configuration
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      Location Configuration
    </Link>,
  ];
  const [backendLocations, setBackendLocations] = useState([]);
  const [draftLocations, setdraftLocations] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [mostRecentDraft, setmostRecentDraft] = useState(null);
  const [maxPages, setMaxPages] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(environment.ElemensPerPage);
  const [isLoading, setIsLoading] = useState(false);
  const [sortingOrder, setSortingOrder] = useState("code");
  const [locationOpened, setLocationOpened] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const sectionLocationsRef = useRef(null);
  const debounceRef = useRef(null);
  const [iataCodesDrop, setIataCodesDrop] = useState(null);
  const [locationDrop, setLocationDrop] = useState(null);
  const [timezonesDrop, setTimeZonesDrop] = useState(null);
  const [filtersOpened, setFiltersOpened] = useState(false);
  const [locationSelected, setLocationSelected] = useState([]);
  const [iataSelected, setIataSelected] = useState([]);
  const [timeZoneSelected, setTimeZoneSelected] = useState([]);
  const [preselectIata, setPreselectIata] = useState();
  const [preselectLocation, setPreselectLocation] = useState();
  const [preselectTimezone, setPreselectTimezone] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [initializeFilters, setInitializeFilters] = useState([
    {
      id: 87,
      columnName: "name",
      isDate: false,
      columnSelection: "name",
    },
    {
      id: 130,
      columnName: "code",
      isDate: false,
      columnSelection: "standard_code",
    },
    {
      id: 131,
      columnName: "timeZone",
      isDate: false,
      columnSelection: "timezone_id",
    },
  ]);

  const getAccountFilter = () => ({
    columnName: "accountId",
    value: [parseInt(localStorage.getItem("u_account_id"))],
  });

  const buildFilterBody = (filters = []) => {
    const filtered = filters.filter(
      (item) => item && item.columnName !== "accountId"
    );

    return [getAccountFilter(), ...filtered];
  };
  const [body, setBody] = useState(buildFilterBody());
  const [viewFilters, setViewFilters] = useState(false);
  const [locationOptionToDelete, setLocationOptionToDelete] = useState(null);
  const [IataOptionToDelete, setIataOptionToDelete] = useState(null);
  const [timezoneOptionToDelete, setTimezoneOptionToDelete] = useState(null);

  // functions
  const getDropdownConfigLocation = async () => {
    let id = 87;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setLocationDrop(request.data.load);
    }
  };

  const getDropdownConfigIataCodes = async () => {
    let id = 130;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setIataCodesDrop(request.data.load);
    }
  };

  const getDropdownConfigTimeZones = async () => {
    let id = 131;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setTimeZonesDrop(request.data.load);
    }
  };
  const getAllDropdowns = async () => {
    const results = await Promise.all([
      getDropdownConfigLocation(),
      getDropdownConfigIataCodes(),
      getDropdownConfigTimeZones(),
    ]);

    return results;
  };

  const handleScroll = () => {
    const section = sectionLocationsRef.current;
    if (section) {
      const { scrollTop, scrollHeight, clientHeight } = section;
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        getMoreLocations();
      }
    }
  };

  const getAllLocations = async (
    p,
    pageSize,
    search = "",
    isScroll = false,
    bodyToSearch = [],
    order = sortingOrder
  ) => {
    setIsLoading(true);
    try {
      let draftLocations = localStorageGet(draftPrefix, {});
      const request = await getLocations(
        p,
        pageSize,
        order,
        bodyToSearch,
        search
      );
      if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
        setMaxPages(request.data.totalPages);

        if (isScroll) {
          setPage((prev) => prev + 1);
          setBackendLocations((prevValues) => {
            return [...prevValues, ...request.data.load];
          });
        } else {
          setPage(1);
          setBackendLocations(request.data.load);
          if (search == "") {
            setdraftLocations(draftLocations);
          } else if (search.trim() !== "") {
            const searchTerm = search.toLowerCase();

            const filteredLocations = draftLocations.filter(
              (location) =>
                (location.name &&
                  location.name.toLowerCase().includes(searchTerm)) ||
                (location.code &&
                  location.code.toLowerCase().includes(searchTerm)) ||
                (location.timezone &&
                  location.timezone.toLowerCase().includes(searchTerm))
            );

            setdraftLocations(
              filteredLocations.length > 0 ? filteredLocations : []
            );
          }
        }
      }
    } catch (error) {
      console.error(
        "something went wrong trying to get more locations : ",
        error
      );
    } finally {
      setIsLoading(false);
    }
  };

  const createNewLocation = async () => {
    const request = await saveLocation();
    if (request.data.responseCode == HTTP_RESPONSE_CODES.CREATED) {
      localStorageSave(
        draftPrefix,
        { locationId: request.data.load.id },
        request.data.load
      );
      setmostRecentDraft(request.data.load.id);
      getAllLocations(page, pageSize, "", false, body, sortingOrder);
    }
  };

  const combineLocations = () => {
    const reversedDraftLocations =
      draftLocations?.length > 0 ? draftLocations : [];

    const uniqueDraftLocations = reversedDraftLocations.filter(
      (draftLocation) =>
        !backendLocations.some(
          (backendLocation) => backendLocation.id === draftLocation.id
        )
    );

    setAllLocations([...uniqueDraftLocations, ...backendLocations]);
  };

  const handleSearchOfLocation = (e) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      getAllLocations(0, pageSize, e, false, body);
    }, environment.debounceTime);
  };

  function generateUUID() {
    return crypto.randomUUID();
  }

  const clearAllFilters = () => {
    setLocationSelected([]);
    setIataSelected([]);
    setTimeZoneSelected([]);

    setPreselectIata(null);
    setPreselectLocation(null);
    setPreselectTimezone(null);
    setBody(buildFilterBody());
    // setAnchorEl(null)
    getAllLocations(0, pageSize, "", false, buildFilterBody(), sortingOrder);
  };

  const getDropdownClearHandler = (columnName, setSelected) => () => {
    setSelected([]);
    setBody((prev) =>
      buildFilterBody(prev.filter((item) => item.columnName !== columnName))
    );
  };

  useEffect(() => {
    if (!filtersOpened) return;

    const filters = [
      locationSelected.length > 0 && {
        columnName: "name",
        value: locationSelected.map((e) => e.name),
      },
      iataSelected.length > 0 && {
        columnName: "code",
        value: iataSelected.map((e) => e.standard_code),
      },
      timeZoneSelected.length > 0 && {
        columnName: "timezone",
        value: timeZoneSelected.map((e) => e.timezone_id),
      },
    ].filter(Boolean);

    const newBody = buildFilterBody(filters);

    if (JSON.stringify(newBody) !== JSON.stringify(body)) {
      setBody(newBody);
      getAllLocations(0, pageSize, "", false, newBody, sortingOrder);
    }
  }, [filtersOpened, locationSelected, iataSelected, timeZoneSelected]);

  useEffect(() => {
    handleSearchOfLocation(searchValue);
  }, [searchValue]);

  useEffect(() => {
    if (filtersOpened) {
      getAllDropdowns();
    }
  }, [filtersOpened]);

  useEffect(() => {
    // getAllLocations(page, pageSize);
    setmostRecentDraft(null);

    dispatch(
      addTab({
        icon: "icon-locations",
        color: "#18C1F6",
        path: "/configuration/locations-configuration",
        title: "Locations",
        isPinned: false,
        componentKey: "LocationsConfiguration",
        id: 13,
        isModule: false,
        date: generateUUID(),
      })
    );
  }, []);

  useEffect(() => {
    const section = sectionLocationsRef.current;
    if (section) {
      section.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (section) {
        section.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  useEffect(() => {
    combineLocations();
  }, [draftLocations, backendLocations]);

  useEffect(() => {
    getAllLocations(0, pageSize, "", false, body, sortingOrder);
  }, [sortingOrder]);

  useEffect(() => {
    if (body.length == 1 || body.length == 0) {
      setAnchorEl(null);
    }
  }, [body]);

  const getSortingOrder = (order) => {
    setSortingOrder(order);
  };

  const reloadAllLocations = (id) => {
    setdraftLocations((prevLocations) => {
      const newDta = prevLocations.filter((loc) => loc.id !== id);
      return newDta;
    });
    setmostRecentDraft(null);
    getAllLocations(0, pageSize, "", false, body, sortingOrder);
  };

  const getMoreLocations = () => {
    if (isLoading || page >= maxPages) {
      return;
    }
    getAllLocations(page, pageSize, "", true, body, sortingOrder);
  };

  const getLocationOpened = (locIdx) => {
    setLocationOpened(locIdx);
  };

  function generateUUID() {
    return crypto.randomUUID();
  }

  const goBackDataObj = {
    icon: "icon-configuration_module_icon",
    color: "#7BB9DB",
    path: "/configuration",
    title: "Configuration",
    isPinned: false,
    componentKey: "Configuration",
    id: 1,
    isModule: true,
    date: generateUUID(),
  };

  // functions to filters manager

  const rawFilters = {
    name: {
      selected: locationSelected,
      setSelected: setLocationSelected,
      setPreselect: setPreselectLocation,
      setToDelete: setLocationOptionToDelete,
      getDisplay: (item) => item.code,
    },
    code: {
      selected: iataSelected,
      setSelected: setIataSelected,
      setPreselect: setPreselectIata,
      setToDelete: setIataOptionToDelete,
      getDisplay: (item) => item.standard_code,
    },
    timezone: {
      selected: timeZoneSelected,
      setSelected: setTimeZoneSelected,
      setPreselect: setPreselectTimezone,
      setToDelete: setTimezoneOptionToDelete,
      getDisplay: (item) => item?.timezone_id || "",
    },
  };

  const filtersConfig = createFiltersConfig(
    rawFilters,
    setBody,
    getAllLocations,
    [0, pageSize, searchValue, false]
  );

  const handleSortingFiltersChange = (fullSelectedMap) => {
    setBody((prevBody) => {
      const updatedBody = [...prevBody];

      Object.entries(fullSelectedMap).forEach(([columnName, fullSelected]) => {
        const existingIndex = updatedBody.findIndex(
          (f) => f.columnName === columnName
        );

        if (!fullSelected || fullSelected.length === 0) {
          if (existingIndex !== -1) {
            updatedBody.splice(existingIndex, 1);
          }

          if (columnName === "code") {
            setIataSelected([]);
          } else if (columnName === "name") {
            setLocationSelected([]);
          } else if (columnName === "timezone") {
            setTimeZoneSelected([]);
          }

          return;
        }

        const valuesOnly = fullSelected.map((item) => {
          if (columnName === "code") return item.standard_code;
          if (columnName === "name") return item.name;
          if (columnName === "timeZone") return item.timezone_id;
          return item;
        });

        if (existingIndex !== -1) {
          updatedBody[existingIndex].value = valuesOnly;
        } else {
          updatedBody.push({ columnName, value: valuesOnly });
        }

        if (columnName === "code") {
          setIataSelected(fullSelected);
        } else if (columnName === "name") {
          setLocationSelected(fullSelected);
        } else if (columnName === "timezone") {
          setTimeZoneSelected(fullSelected);
        }
      });

      getAllLocations(0, pageSize, "", false, updatedBody, sortingOrder);
      return updatedBody;
    });
  };

  const handleFiltersChange = (data) => {
    const updatedData = buildFilterBody(data);
    setBody(updatedData);
    getAllLocations(0, pageSize, searchValue, false, updatedData, sortingOrder);
  };
  return (
    <>
      <SortingProvider
        onOrderChange={getSortingOrder}
        properties={{
          code: "IATA Code",
          name: "Location",
          timeZone: "TimeZone",
        }}
        columnFilterProperties={{
          code: 130,
          name: 87,
          timeZone: 131,
        }}
        generalFilters={initializeFilters}
      >
        <main className="locations-config">
          <div
            className="locations-nav-cont"
            // style={{
            //   height: filtersOpened ? "9rem" : "5.5rem",
            // }}
          >
            <NavBar
            totalRecords={allLocations.length}

              dataBreadCrumbs={"/configuration/locations-configuration"}
              appIcon={"icon-locations"}
              moduleIcon={"icon-settings"}
              moduleColor="rgb(24, 193, 246)"
              title={"Locations"}
              menuTitle={"Configuration"}
              moduleId={1}
              goBackData={goBackDataObj}
              isLocalSearch
              searchInputProps={{
                type: "text",
                onTextChange: (e) => setSearchValue(e),
              }}
              screenActions={
                <button
                  className="btn-icon-addNew-location"
                  onClick={createNewLocation}
                  style={{
                    margin: "0 auto 0 0 ",
                  }}
                >
                  <i className="icon-add-new"></i>

                  <p>New Location</p>
                </button>
              }
              searchActions={
                <>
                  <FiltersManager
                    appliedFilters={body}
                    onFilterChange={setBody}
                    handleClearAllFilters={clearAllFilters}
                    excludeColumns={["accountId"]}
                    onButtonClick={() => {
                      setFiltersOpened(!filtersOpened);
                    }}
                    onClearGroup={(col) => filtersConfig[col]?.clearGroup?.()}
                    onDeleteFilter={(col, val) =>
                      filtersConfig[col]?.deleteValue?.(val)
                    }
                    getFilterLabel={(col) => filtersConfig[col]?.label || col}
                    getDisplayValue={(col, val) =>
                      filtersConfig[col]?.getDisplayValue(val) || val
                    }
                  />

                  <SortingButton></SortingButton>
                </>
              }
            ></NavBar>

            <FiltersAndSorting
              viewFilters={filtersOpened}
              onFiltersChange={handleFiltersChange}
            ></FiltersAndSorting>
          </div>

          <div className="location-list-parent-div">
            {/* <SortingHeader
              valuesExtractor={{
                name: (items) => items.map((i) => i.name),
                code: (items) => items.map((i) => i),
                timeZone: (items) => items.map((i) => i.timezone_id),
              }}

              onFiltersSelected={(newFiltersArray, fullSelectedMap) => {
                handleSortingFiltersChange(fullSelectedMap)
              }}

            /> */}

            <section
              className="locations-config-locationsCont"
              ref={sectionLocationsRef}
            >
              {allLocations.length > 0 ? (
                <LocationsContextProvider>
                  {allLocations.map((location, idx) => {
                    return (
                      <ExpandableConfigModComponent
                        key={location.id}
                        headerData={location}
                        emitlocationUpdatedEvent={reloadAllLocations}
                        isDraft={
                          draftLocations?.length > 0
                            ? draftLocations.some((e) => e.id === location.id)
                            : null
                        }
                        isNewDraft={
                          location.id == mostRecentDraft && location.id != null
                        }
                        idx={idx}
                        locationOpened={locationOpened}
                        emitLocationOpened={getLocationOpened}
                        savedInBackend={backendLocations.some(
                          (backendLocation) =>
                            backendLocation.id === location.id
                        )}
                      />
                    );
                  })}
                </LocationsContextProvider>
              ) : (
                <ResultsNotFound />
              )}

              {/* <List
              height={Math.floor(window.innerHeight * 0.795)}
              itemCount={allLocations.length}
              itemSize={50} // Adjust this value according to the height of your items
              width={"100%"} // Adjust this value as needed
              itemData={{ allLocations, draftLocations, reloadAllLocations }}
            >
              {Item}
            </List> */}
            </section>
          </div>
        </main>
      </SortingProvider>
    </>
  );
};
